import {DownloadPageData} from '../types';
import {downloadPageData_Alpha} from './alpha';
import {downloadPageData_Beta} from './beta';
import {downloadPageData_Launch} from './launch';
import {downloadPageData_Main} from './main';
import {downloadPageData_Invite} from './invite';
import {InviteParameters} from './interface';
import {downloadPageData_PreLaunch} from './prelaunch';
import {downloadPageData_ShareStory} from './share-story';

export enum PageType {
  DOWNLOAD_ALPHA = 'download_alpha',
  DOWNLOAD_BETA = 'download_beta',
  DOWNLOAD_PRELAUNCH = 'download_prelaunch',
  LAUNCH = 'launch',
  DOWNLOAD_MAIN = 'main',
  DOWNLOAD_INVITE = 'invite',
  DOWNLOAD_SHARE_STORY = 'share_story',
}

export const downloadPageData: {
  [key in PageType]: DownloadPageData | DownloadPageData<InviteParameters>;
} = {
  [PageType.DOWNLOAD_ALPHA]: downloadPageData_Alpha,
  [PageType.DOWNLOAD_BETA]: downloadPageData_Beta,
  [PageType.DOWNLOAD_PRELAUNCH]: downloadPageData_PreLaunch,
  [PageType.LAUNCH]: downloadPageData_Launch,
  [PageType.DOWNLOAD_MAIN]: downloadPageData_Main,
  [PageType.DOWNLOAD_INVITE]: downloadPageData_Invite,
  [PageType.DOWNLOAD_SHARE_STORY]: downloadPageData_ShareStory,
};
